import React from "react";
import PropTypes from "prop-types";
import { mediaOutletUrl } from "views_shared/app/javascript/utils/urls";
import SavedGroupsBookmark from "../../source_directory/SavedGroupsBookmark";
import LogoTile from "../../source_directory/LogoTile";
import HighlightAttribute, { attributeMatched } from "../../source_directory/HighlightAttribute";
// Excerpt is a plain "first N words, then Show more" block with nothing PR-specific about it; it
// simply happens to live where it was first written.
import Excerpt from "../../pr_profiles/card/Excerpt";
import OutletBadges from "./OutletBadges";
import mediaUserCount from "./mediaUserCount";

function MediaOutletCardGrid({ hit }) {
  return (
    <div
      className="animated faster fadeIn"
      style={{
        gridRow: "span 3",
        display: "grid",
        gridTemplateRows: "subgrid",
        borderRadius: 10,
        border: "1px solid #e5e7eb",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      {/* Row 1: Header */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12, padding: "16px 16px 14px" }}>
        <LogoTile imageUrl={hit.profile_image_url} name={hit.display_name} size={60} fontSize={18} borderRadius={8} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 16 }}>
            <a href={mediaOutletUrl({ slug: hit.slug, migrate_id: hit.migrate_id })} style={{ color: "#111827" }}>
              <HighlightAttribute hit={hit} attribute="display_name" fallback={hit.display_name} />
            </a>
          </div>
          {hit.domain && (
            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>
              <HighlightAttribute hit={hit} attribute="domain" fallback={hit.domain} />
            </div>
          )}
          <OutletBadges prestige={hit.prestige} outletClassification={hit.outlet_classification} />
        </div>
        <SavedGroupsBookmark
          sourceableType="Id::MediaOutlet"
          sourceableId={hit.id}
          sourceMeta={{ name: hit.display_name, imageUrl: hit.profile_image_url, slug: hit.slug }}
        />
      </div>

      {/* Row 2: Separator — full-width (no padding; overflow:hidden on card clips to border-radius) */}
      <div style={{ height: 1, backgroundColor: "#e9e9e9" }} />

      {/* Row 3: Content */}
      <div style={{ padding: "8px 16px 16px" }}>
        <div style={{ fontSize: 13, color: "#4d5357" }}>{mediaUserCount(hit.reporter_count)}</div>

        {hit.description && hit.description.length > 0 && (
          <div style={{ marginTop: 10, fontSize: 13, color: "#4d5357" }}>
            {attributeMatched(hit, "description") ? (
              <HighlightAttribute hit={hit} attribute="description" fallback={hit.description} />
            ) : (
              <Excerpt text={hit.description} maxWords={25} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

MediaOutletCardGrid.propTypes = {
  hit: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    slug: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    domain: PropTypes.string,
    description: PropTypes.string,
    profile_image_url: PropTypes.string,
    prestige: PropTypes.string,
    outlet_classification: PropTypes.string,
    reporter_count: PropTypes.number,
  }).isRequired,
};

export default MediaOutletCardGrid;
